import * as UNDO_REDO from 'services/UndoRedoService/constants/undoRedo';

export const getAction = (actionName, data = null) => {

  let action = {};

  switch (actionName) {
    case UNDO_REDO.EVENT_NAMES.MOVE_STAGE_ELEMENTS:
      action = { 
        name: UNDO_REDO.EVENT_NAMES.MOVE_STAGE_ELEMENTS,
        undo: UNDO_REDO.EVENT_NAMES.MOVE_STAGE_ELEMENTS,
        redo: UNDO_REDO.EVENT_NAMES.MOVE_STAGE_ELEMENTS,
        data: data,
        elementType: UNDO_REDO.ELEMENT_CONFIG_TYPES.INTERACTIVE,
      };
      break;
    case UNDO_REDO.EVENT_NAMES.PASTE_ELEMENTS:
      action = {
        name: UNDO_REDO.EVENT_NAMES.PASTE_ELEMENTS,
        undo: UNDO_REDO.REVERT_CONFIG,
        redo: UNDO_REDO.REVERT_CONFIG,
        data: null,
        editorState: data.editorState,
        elementType: UNDO_REDO.ELEMENT_CONFIG_TYPES.INTERACTIVE,
      };
      break;
    case UNDO_REDO.EVENT_NAMES.PASTE_COMPONENTS:
      action = {
        name: UNDO_REDO.EVENT_NAMES.PASTE_COMPONENTS,
        undo: UNDO_REDO.DELETE_COMPONENT,
        redo: UNDO_REDO.RESTORE_COMPONENT,
        data: data.data,
        editorState: data.editorState,
        elementType: UNDO_REDO.ELEMENT_CONFIG_TYPES.INTERACTIVE,
      };
      break;
    case UNDO_REDO.EVENT_NAMES.UPDATE_INLINE_ICON:
      action = {
        name: UNDO_REDO.EVENT_NAMES.UPDATE_INLINE_ICON,
        undo: UNDO_REDO.REVERT_CONFIG,
        redo: UNDO_REDO.REVERT_CONFIG,
        data: data,
        elementType: UNDO_REDO.ELEMENT_CONFIG_TYPES.INTERACTIVE,
      };
      break;
    case UNDO_REDO.EVENT_NAMES.COMPONENTS_STAGE:
      action = {
        name: UNDO_REDO.EVENT_NAMES.COMPONENTS_STAGE,
        undo: UNDO_REDO.REVERT_COMPONENT_CONFIG,
        redo: UNDO_REDO.REVERT_COMPONENT_CONFIG,
        data: data,
        elementType: UNDO_REDO.ELEMENT_CONFIG_TYPES.COMPONENT,
      };
      break;
    case UNDO_REDO.EVENT_NAMES.COMPONENTS_SIDEBAR:
      action = {
        name: UNDO_REDO.EVENT_NAMES.COMPONENTS_SIDEBAR,
        undo: UNDO_REDO.REVERT_COMPONENT_CONFIG,
        redo: UNDO_REDO.REVERT_COMPONENT_CONFIG,
        data: data,
        elementType: UNDO_REDO.ELEMENT_CONFIG_TYPES.COMPONENT,
      };
      break;
    case UNDO_REDO.EVENT_NAMES.COMPONENTS_SIDEBAR_INSTRUCTOR_GRADING:
      action = {
        name: UNDO_REDO.EVENT_NAMES.COMPONENTS_SIDEBAR_INSTRUCTOR_GRADING,
        undo: UNDO_REDO.REVERT_MANUAL_GRADING_CONFIG,
        redo: UNDO_REDO.REVERT_MANUAL_GRADING_CONFIG,
        data: data,
        elementType: UNDO_REDO.ELEMENT_CONFIG_TYPES.COMPONENT,
      };
      break;
    case UNDO_REDO.EVENT_NAMES.ELEMENTS_SIDEBAR:
      action = {
        name: UNDO_REDO.EVENT_NAMES.ELEMENTS_SIDEBAR,
        undo: UNDO_REDO.REVERT_CONFIG,
        redo: UNDO_REDO.REVERT_CONFIG,
        data: null,
        elementType: UNDO_REDO.ELEMENT_CONFIG_TYPES.INTERACTIVE,
      };
      break;
    default:
      break;
  }
  return action;
};